import { Routes } from '@angular/router';
import { ContentLayoutComponent } from '@app/layout/content-layout/content-layout.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { AuthLayoutComponent } from '@app/layout/auth-layout/auth-layout.component';
import { CommonLayoutComponent } from '@app/layout/common-layout/common-layout.component';
import { environment } from '@env';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        pathMatch: 'full',
        loadChildren: () => import('@features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'project',
        pathMatch: 'prefix',
        loadChildren: () => import('@features/project/project.routes').then((m) => m.PROJECT_ROUTES),
      },
      {
        path: 'projects',
        pathMatch: 'full',
        loadChildren: () => import('@features/projects/projects.routes').then((m) => m.PROJECTS_ROUTES),
      },
      {
        path: 'documentations',
        pathMatch: 'full',
        loadChildren: () =>
          import('@features/documentations/documentations.routes').then((m) => m.DOCUMENTATIONS_ROUTES),
      },
      {
        path: 'export',
        pathMatch: 'prefix',
        loadChildren: () =>
          import('@features/export-assistant/export-assistant.routes').then((m) => m.EXPORT_ASSISTANT_ROUTES),
      },
      {
        path: 'repository',
        pathMatch: 'prefix',
        loadChildren: () => import('@features/repository/repository.routes').then((m) => m.REPOSITORY_ROUTES),
      },
      {
        path: 'bin',
        pathMatch: 'prefix',
        // Zamiast m.BinModule, ładujemy plik z trasami standalone
        loadChildren: () => import('@features/bin/bin.routes').then((m) => m.BIN_ROUTES),
      },
      {
        path: 'user',
        pathMatch: 'prefix',
        loadChildren: () => import('@features/user-profile/user-profile.routes').then((m) => m.USER_PROFILE_ROUTES),
      },
      {
        path: 'main-account',
        pathMatch: 'prefix',
        loadChildren: () => import('@features/main-account/main-account.routes').then((m) => m.MAIN_ACCOUNT_ROUTES),
      },
      {
        path: 'admin-main-accounts',
        pathMatch: 'prefix',
        loadChildren: () =>
          import('@features/admin-main-accounts/admin-main-accounts.routes').then((m) => m.ADMIN_MAIN_ACCOUNTS_ROUTES),
      },
    ],
  },
  {
    path: 'login',
    component: AuthLayoutComponent,
    loadChildren: () => import('@features/auth/login/login.routes').then((m) => m.LOGIN_ROUTES),
  },
  {
    path: 'auth', // Zmieniamy ścieżkę aby uniknąć konfliktu
    component: CommonLayoutComponent,
    children: [
      {
        path: 'register',
        loadChildren: () => import('@features/auth/register/register.routes').then((m) => m.REGISTER_ROUTES),
      },
      {
        path: 'register-demo',
        loadChildren: () => import('@features/auth/register-demo/register-demo.routes').then((m) => m.REGISTER_DEMO_ROUTES),
      },
      {
        path: 'password-recover',
        loadChildren: () =>
          import('@features/auth/password-recover/password-recover.routes').then((m) => m.PASSWORD_RECOVER_ROUTES),
      },
      {
        path: 'password-reset',
        loadChildren: () =>
          import('@features/auth/password-reset/password-reset.routes').then((m) => m.PASSWORD_RESET_ROUTES),
      },
    ],
  },
  {
    path: 'register',
    redirectTo: 'auth/register',
    pathMatch: 'full',
  },
  {
    path: 'register-demo',
    redirectTo: 'auth/register-demo',
    pathMatch: 'full',
  },
  {
    path: 'password-recover',
    redirectTo: 'auth/password-recover',
    pathMatch: 'full',
  },
  {
    path: 'password-reset',
    redirectTo: 'auth/password-reset',
    pathMatch: 'full',
  },
  // Prototyp okna przenoszenia z eksportu do dokumentacji na danych przykładowych — poza buildem produkcyjnym.
  ...(environment.production
    ? []
    : [
        {
          path: 'export-transfer-demo',
          loadComponent: () =>
            import('@features/export-transfer-demo/export-transfer-demo.component').then((m) => m.ExportTransferDemoComponent),
        },
      ]),
  {
    path: '404',
    loadChildren: () => import('@features/not-found/not-found.routes').then((m) => m.NOT_FOUND_ROUTES),
  },
  {
    path: 'message-view',
    loadChildren: () => import('@features/message-view/message-view.routes').then((m) => m.MESSAGE_VIEW_ROUTES),
  },
  // Usuwamy problematyczną ścieżkę z redirectTo: 'login'
  { path: '**', pathMatch: 'full', redirectTo: '/404' },
];

if (environment.electron && APP_ROUTES[0].children) {
  APP_ROUTES[0].children.push({
    path: 'pi-drive-settings',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('@features/pi-drive-settings/pi-drive-settings.routes').then((m) => m.PI_DRIVE_SETTINGS_ROUTES),
  });
}
